export default "__VITE_PUBLIC_ASSET__7b70e2fe__"